import DeptList from '@/pages/components/manage/sys/dept/DeptList';

export default {
    list: DeptList,
    recordRepresentation: 'deptName',
};
